import { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import useComponentVisible from '../hooks/useComponentVisible';
import FavoriteFilter from './FavoriteFilter';

HcpFilters.propTypes = {
    hcpFavoriteCheckbox: PropTypes.bool.isRequired,
    setHcpFavoriteCheckbox: PropTypes.func.isRequired,
    highOpportunityCheckbox: PropTypes.bool.isRequired,
    setHighOpportunityCheckbox: PropTypes.func.isRequired,
    hcpOpportunityEnabled: PropTypes.bool.isRequired,
    showHighOpportunityFilter: PropTypes.bool.isRequired,
};

export default function HcpFilters({
    hcpFavoriteCheckbox,
    setHcpFavoriteCheckbox,
    highOpportunityCheckbox,
    setHighOpportunityCheckbox,
    hcpOpportunityEnabled,
    showHighOpportunityFilter,
}) {
    const [appState] = useContext(AppContext);
    const [filterMenuRef, filterMenuIsVisible, setFilterMenuIsVisible, filterContentRef] = useComponentVisible(false);
    const buttonContainerRef = useRef(null);
    const hcpFavoritesEnabled = getConfigValue(appState.config?.HCP?.Favorites?.Enabled, appState)?.Value === 'true';
    const defaultFavoriteFilterValue = getConfigValue(appState.config?.HCP?.Favorites?.Filter?.Default, appState)?.Value === 'true';
    const highOpportunityFilterLabel = getConfigValue(appState.config?.Target?.SelectHcp?.Filter?.HighOpportunity?.Label, appState)?.Value || 'High Opportunity';

    function handleReset(event) {
        event.preventDefault();
        setHcpFavoriteCheckbox(defaultFavoriteFilterValue);
        setHighOpportunityCheckbox(false);
    }

    if (!hcpFavoritesEnabled) {
        return null;
    }

    return (
        <div className='row my-4'>
            <div className='col-12 col-md-4 col-lg-3 ms-md-auto d-flex'>
                <div ref={buttonContainerRef} className='dropdown flex-fill d-flex'>
                    <button
                        ref={filterMenuRef}
                        type='button'
                        className='btn btn-outline-primary btn-icon w-100'
                        onClick={() => setFilterMenuIsVisible(!filterMenuIsVisible)}
                        data-bs-toggle='collapse'
                        data-bs-target='#options-row-1'
                        aria-expanded={filterMenuIsVisible ? 'true' : 'false'}
                        aria-controls='options-row-1'
                        data-bs-auto-close='outside'
                    >
                        {getConfigValue(appState.config?.Target?.SelectHcp?.Filter?.Title, appState)?.Value}
                        <span className='fa-regular fa-chevron-down btn-icon'></span>
                    </button>
                </div>
                {filterMenuIsVisible && (
                    <div ref={filterContentRef} style={{ display: 'block', minWidth: buttonContainerRef.current?.offsetWidth ?? 0 }} className='temp-user-dropdown-filters'>
                        <div className='row justify-content-center align-items-center'>
                            <div className='col-10 pt-2 px-2 pb-3'>
                                <div className='d-flex justify-content-between align-items-center border-bottom mb-3'>
                                    <h3 className='type-bold type-16 mt-2 mb-2'>{getConfigValue(appState.config?.Target?.SelectHcp?.Filter?.Title, appState)?.Value}</h3>
                                    <button type='button' className='btn btn-link p-0' onClick={handleReset}>{getConfigValue(appState.config?.Target?.SelectHcp?.Filter?.Reset?.Label, appState)?.Value}</button>
                                </div>
                                <FavoriteFilter
                                    hcpFavoriteCheckbox={hcpFavoriteCheckbox}
                                    setHcpFavoriteCheckbox={setHcpFavoriteCheckbox}
                                    includeWrappingRow={false}
                                    showTooltipIcon={true}
                                />
                                {hcpOpportunityEnabled && showHighOpportunityFilter && (
                                    <div className='d-flex justify-content-between align-items-center mt-3'>
                                        <div className='form-check mb-0'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='list-filter-high-opportunity'
                                                checked={highOpportunityCheckbox}
                                                onChange={(event) => setHighOpportunityCheckbox(event.target.checked)}
                                            ></input>
                                            <label className='form-check-label type-14' htmlFor='list-filter-high-opportunity'>
                                                {highOpportunityFilterLabel}
                                            </label>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
